import { render, staticRenderFns } from "./birthdate-input.vue?vue&type=template&id=29cf5374&scoped=true&"
import script from "./birthdate-input.vue?vue&type=script&lang=js&"
export * from "./birthdate-input.vue?vue&type=script&lang=js&"
import style0 from "./birthdate-input.vue?vue&type=style&index=0&id=29cf5374&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cf5374",
  null
  
)

export default component.exports